var map = {
	"./Ws01.jpg": 49613,
	"./Ws02.jpg": 38409,
	"./Ws03.jpg": 78642,
	"./Ws04.jpg": 89280,
	"./Ws05.jpg": 18192,
	"./Ws06.jpg": 42112,
	"./Ws07.jpg": 78893,
	"./Ws08.jpg": 83089,
	"./Ws09.jpg": 52974,
	"./Ws10.jpg": 37416,
	"./Ws11.jpg": 30989,
	"./Ws12.jpg": 10438,
	"./Ws13.jpg": 73253,
	"./Ws14.jpg": 29042,
	"./Ws15.jpg": 26648,
	"./Ws16.jpg": 2622,
	"./Ws17.jpg": 24536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75257;